define('taoQtiItem/qtiItem/core/interactions/AssociateInteraction',['taoQtiItem/qtiItem/core/interactions/BlockInteraction'], function(BlockInteraction){
    var AssociateInteraction = BlockInteraction.extend({
        qtiClass : 'associateInteraction'
    });
    return AssociateInteraction;
});



